<ion-radio-group *ngIf="options" [(ngModel)]="selectedValue" (ionChange)="mapToControl($event)">
  <ion-item
    *ngFor="let option of options"
    id="{{ id }}-{{ option.value }}"
    class="ion-margin-bottom"
    [class.no-padding-end]="!!option.description"
    lines="none"
  >
    <ion-radio slot="start" class="aux-radio" mode="md" color="secondary" [value]="option.value"></ion-radio>
    <ion-label class="radio-label-container">
      <ion-text class="main-text ion-text-wrap">{{ option.text | translate }}</ion-text>
      <ion-text class="sub-text ion-text-wrap">{{ option.subtext }}</ion-text>
    </ion-label>
    <div slot="end" class="info-btn-container ion-no-margin">
      @if (option.description){
      <ion-button [id]="'open_info-' + option.value" color="secondary" expand="block" mode="md" fill="clear">
        <fa-icon slot="end" size="xl" [icon]="faInfoCircle"></fa-icon>
      </ion-button>

      <ion-modal #modal [trigger]="'open_info-' + option.value" class="description-card" [breakpoints]="[0, 1]" [initialBreakpoint]="1">
        <ng-template>
          <ion-header>
            <ion-toolbar>
              <ion-title></ion-title>
              <ion-buttons slot="end">
                <ion-button color="primary" mode="md" (click)="modal.dismiss()">Close</ion-button>
              </ion-buttons>
            </ion-toolbar>
          </ion-header>
          <ion-content class="ion-padding">
            <ion-text>
              <h1>{{ option.text }}</h1>
            </ion-text>
            <p [innerHtml]="option.description"></p>
          </ion-content>
        </ng-template>
      </ion-modal>
      }
    </div>
  </ion-item>
</ion-radio-group>
